class DataParserService {

    static isNumber(value) {
        return !isNaN(value)
    }
}

export default DataParserService;
